import { ReactNode, useCallback } from "react";
import { useAppSelector } from "../../../Redux/redux-store";
import { GetSectionIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";

export type FormSectionValidityProps = {
  showWhenValid?: ReactNode | undefined;
  showWhenNotValid?: ReactNode | undefined;
  sectionId: string;
  formId: string;
};

const FormSectionValidity: React.FC<FormSectionValidityProps> = (props) => {
  const { showWhenNotValid, showWhenValid, sectionId, formId } = props;

  const isValid = useAppSelector(GetSectionIsValid(formId, sectionId));

  const renderElement = useCallback(
    () => (isValid ? showWhenValid ? <>{showWhenValid}</> : <></> : showWhenNotValid ? <>{showWhenNotValid}</> : <></>),
    [isValid, showWhenNotValid, showWhenValid, sectionId, formId]
  );

  return <>{renderElement()}</>;
};

export default FormSectionValidity;
